import { api } from "./apiClient";

export const assetService = {
  list: async (params = {}) => (await api.get("/admin/assets", { params })).data,
  sources: async () => (await api.get("/admin/assets/sources")).data,
  limits: async () => (await api.get("/admin/assets/limits")).data,
  discover: async (search = "", market = "crypto") =>
    (await api.get("/admin/assets/discover", { params: { search, market } })).data,
  create: async (payload) => (await api.post("/admin/assets", payload)).data,
  update: async (id, payload) => (await api.patch(`/admin/assets/${id}`, payload)).data,
  bulkVisibility: async (ids, visible) =>
    (await api.post("/admin/assets/bulk-visibility", { ids, visible })).data,
  remove: async (id) => (await api.delete(`/admin/assets/${id}`)).data,
};
